import axios, { AxiosInstance } from 'axios';
import * as Sentry from '@sentry/vue';

export const client: AxiosInstance = Object.assign(
  axios.create({
    baseURL: process.env['VUE_APP_API_ORIGIN'],
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    timeout: 1000 * 30
  })
);

export async function post(url: string, data: any) {
  try {
    const response = await client.post(url, data);
    return response;
  } catch (error) {
    if (!/^40[0-8]/.test(error?.response?.status)) {
      Sentry.captureException(error, {
        extra: {
          url: url,
          data: data
        }
      });
    }
    throw error;
  }
}

export async function postUserSessionsVerify() {
  try {
    const response = await client.post('/api/v1/user_sessions/verify');
    return response;
  } catch (error) {
    if (!/^40[0-8]/.test(error?.response?.status)) {
      Sentry.captureException(error, {
        extra: {
          url: '/api/v1/user_sessions/verify'
        }
      });
    }
    throw error;
  }
}

export async function put(url: string, data: any) {
  try {
    const response = await client.put(url, data);
    return response;
  } catch (error) {
    if (!/^40[0-8]/.test(error?.response?.status)) {
      Sentry.captureException(error, {
        extra: {
          url: url,
          data: data
        }
      });
    }
    throw error;
  }
}

export async function putAccountId(account_id_reset_token: string) {
  try {
    const response = await client.put('/api/v1/account_id', {
      account_id_reset_token
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function get(url: string) {
  try {
    const response = await client.get(url);
    return response;
  } catch (error) {
    if (!/^40[0-8]/.test(error?.response?.status)) {
      Sentry.captureException(error, {
        extra: {
          url: url
        }
      });
    }
    throw error;
  }
}
